/* eslint-disable */
import BasicLayout from '@/layouts/basic-layout';

// 基础元信息配置
// TODO: 考虑添加更细粒度的权限控制
const meta = {
  auth: true, // 需要登录认证
  // TODO: 添加角色权限配置
  // roles: ['admin', 'distributor_manager']
};

const pre = 'distribution-';

export default {
  path: '/distribution',
  name: 'distribution',
  redirect: {
    // 默认重定向到分销商管理页面
    // TODO: 可以根据用户角色动态设置默认页面
    name: `${pre}distributor`,
  },
  meta: {
    ...meta,
    title: '分销管理',
    icon: 'el-icon-s-marketing', // TODO: 使用合适的图标
  },
  component: BasicLayout,
  children: [
    // ==================== 核心业务模块 ====================
    {
      path: 'distributor',
      name: `${pre}distributor`,
      meta: {
        ...meta,
        title: '分销商管理',
        // TODO: 添加面包屑导航配置
        breadcrumb: ['分销管理', '分销商管理'],
      },
      component: () => import('@/pages/distribution/distributor'),
    },
    {
      path: 'orders',
      name: `${pre}orders`,
      meta: {
        ...meta,
        title: '分销订单',
        // TODO: 添加权限标识
        permission: 'distribution:order:list',
      },
      component: () => import('@/pages/distribution/orders'),
    },
    {
      path: 'commission',
      name: `${pre}commission`,
      meta: {
        ...meta,
        title: '佣金管理',
        // 财务相关页面需要更高权限
        roles: ['admin', 'finance'],
      },
      component: () => import('@/pages/distribution/commission'),
    },
    {
      path: 'goods',
      name: `${pre}goods`,
      meta: {
        ...meta,
        title: '分销商品',
      },
      component: () => import('@/pages/distribution/goods'),
    },
    {
      path: 'invite',
      name: `${pre}invite`,
      meta: {
        ...meta,
        title: '邀请关系',
      },
      component: () => import('@/pages/distribution/invite'),
    },
  ],
};